"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hashCode = exports.hashCode = function hashCode(str) {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

var _makeBrighter = exports._makeBrighter = function _makeBrighter(hex) {
  hex = hex.split("");
  hex[1] = "F";
  return hex.join("");
};

var intToRGB = exports.intToRGB = function intToRGB(i) {
  var offLimits = /[0-9a-e]/gi;
  var c = (i & 0x00ffffff).toString(16).toUpperCase();
  c = "#" + "00000".substring(0, 6 - c.length) + c;
  return c[1].match(offLimits) ? _makeBrighter(c) : c;
};

var colors = {};

var getColor = exports.getColor = function getColor(pkgName) {
  if (!colors[pkgName]) {
    var code = hashCode(pkgName);
    colors[pkgName] = intToRGB(code);
  }
  return colors[pkgName];
};
//# sourceMappingURL=colors.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/util/colors.js
// module id = 159
// module chunks = 0